<template>
	<div>
		<app-overlay-loader v-if="!dataLoaded" />
		<div v-else class="content-wrapper">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<app-breadcrumb :button="{ label: $t('back'), url: urlGenerator(`crm/fund/list`) }"
						:directory="[$t('contacts'), name]" :icon="'users'" :page-title="name" />
				</div>
			</div>
			<div class="row">
				<div class="col-xl-4">
					<component is="app-user-info-details-fund"
						:user-info-sync-url="`crm/funds/profile-picture/${formData.id}`" :user-info-data="formData"
						component-type="fund" @update-request="updateRequest" />

					<app-details-information-fund-more class="mb-primary" :details-data="formData"
						:details-sync-url="`crm/funds/${formData.id}`" @update-request="updateRequest" />

					<app-details-information-manne class="mb-primary" :details-sync-url="`crm/funds/${formData.id}`"
						:details-data="formData" @update-request="updateRequest" />

					<template v-if="this.user.role == 'Разработчик'">
						<app-details-information-fund-price class="mb-primary" :details-data="formData"
							:details-sync-url="`crm/funds/${formData.id}`" @update-request="updateRequest" />
					</template>

					<template v-if="this.user.role == 'Собственник'">
						<app-details-information-fund-price class="mb-primary" :details-data="formData"
							:details-sync-url="`crm/funds/${formData.id}`" @update-request="updateRequest" />
					</template>

					<template v-if="this.user.role == 'Менеджер зала'">
						<app-details-information-fund-price class="mb-primary" :details-data="formData"
							:details-sync-url="`crm/funds/${formData.id}`" @update-request="updateRequest" />
					</template>

					<template v-if="this.user.role == 'Финансист'">
						<app-details-information-fund-price class="mb-primary" :details-data="formData"
							:details-sync-url="`crm/funds/${formData.id}`" @update-request="updateRequest" />
					</template>
				</div>
				<div class="col-xl-8">
					<div class="row">
						<div class="col-xl-6">
							<app-details-information-fund class="mb-primary" :details-data="formData"
								:details-sync-url="`crm/funds/${formData.id}`" :block-edit="blockEdit" @update-request="updateRequest" @update-block="updateBlock" @update-unblock="updateUnblock"/>
						</div>
						<div class="col-xl-6">
							<app-details-information-fund-invent class="mb-primary" :block-edit="blockEdit" :details-data="formData"
								:details-sync-url="`crm/funds/${formData.id}`" @update-request="updateRequest" @update-block="updateBlock" @update-unblock="updateUnblock"/>

						</div>
						<div class="col-xl-12 mb-primary">
							<div class="card border-0 card-with-shadow">
								<div
									class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
									<h5 class="card-title text-muted mb-0">{{ $t('renewe_card') }}</h5>
									<div>
										<button type="button" class="btn btn-primary btn-with-shadow"
											data-toggle="modal" @click="addRenewe()">
											{{ $t("add_renewe") }}
										</button>
									</div>
								</div>
								<div class="card-body">
									<div class="card-renewe" v-if="formData.renewe.length">
										<app-table v-if="loadRenewe" :id="tableId" :options="options" />
										<app-overlay-loader v-else />
									</div>
									<div v-else>
										{{ $t('no_renewe_card') }}
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-12">
							<app-tab v-if="appTapShow" :tabs="todoActivityTab" class="mb-primary" type="horizontal" />
							<app-common-activity-show-fund :Data="formData" :edit-url="selectedUrl"
								:file-note-url="`crm/fund`" component-type="fund" v-if="isComponent"
								@open-note-modal="editNote" />
						</div>
					</div>
				</div>
			</div>
			<app-common-note-modal v-if="isNoteModal" :note="noteRowData" @close-modal="closeNoteModal" />
		</div>
		<app-renewe-modal
      v-if="isReneweModalActive"
      :table-id="tableId"
      :fund-data="formData"
      :selected-url="''"
      @close-modal="closeModal"
    />
	</div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, onlyTime, onlyTimeFromTime, textTruncate, urlGenerator, numberWithCurrencyMuseum} from "@app/Helpers/helpers";
export default {
	props: ["selectedUrl"],
	name: "FundDetails",
	mixins: [FormMixin],


	data() {
		return {
			urlGenerator,
			numberWithCurrencyMuseum,
			blockEdit: false,
			isReneweModalActive: false,
			dataLoaded: false,
			loadRenewe: false,
			preLoader: false,
			tableId: 'renewe-modal',
			isDealModalActive: false,
			isNoteModal: false,
			fundActivitiesModal: false,
			formData: {},
			appTapShow: false,
			isComponent: true,
			name: "",
			editedUrl: "",
			activitiesList: [],
			isfileNoteFilter: true,

			// Tab Start
			todoActivityTab: [
				{
					name: this.$t("note"),
					icon: "file-text",
					component: "common-note-tab",
					props: "",
					permission: "",
				},
				{
					name: this.$t("file"),
					icon: "paperclip",
					component: "common-file-tab",
					props: "",
					permission: "",
				},

				
				
			],


			rowData: null,
			dealNoteModal: false,
			noteRowData: null,
			value: "",
			formatDateToLocal,
			onlyTimeFromTime,
			onlyTime,
			textTruncate,
			options: {},
    
		};
	},
	computed: {
		fundList() {
			return this.$store.getters.getFund
		},


		
	},
	methods: {
		


		closeModal() {
			this.isReneweModalActive = false;
			$("#renewe-modal").modal("hide");
		},
		afterSuccessFromGetEditData(response) {
			this.formData = response.data;
			this.name = this.formData.name;
			this.todoActivityTab.forEach((el) => {
				el["props"] = {
					id: this.formData.id,
					fund: "fund",
					contextable_type: "App\\Models\\CRM\\Fund\\Fund",

					fileSyncUrl: `crm/fund/file/sync/${this.formData.id}`,
					noteSyncUrl: `crm/fund/note/sync/${this.formData.id}`,
				};
			});

			this.appTapShow = true;
			this.dataLoaded = true;
			this.getRenewe();
		},
		addRenewe(){
			this.isReneweModalActive = true;
		},

		setUser() {
			this.user = {
				full_name: window.user.full_name,
				img: window.user.profile_picture
					? urlGenerator(window.user.profile_picture.path)
					: urlGenerator("/images/profile.png"),
				status: this.$t("online"),
				role: this.$t(window.user.roles[0].name),
			};
		},
		
		getRenewe(){
			this.options = {
				name: this.$t("renewe_table"),
				url: "crm/renewesid?fund=" + this.formData.id,
				showHeader: true,
				countView: false,
				columns: [
					{
						title: this.$t("status"),
						type: "custom-html",
						key: "status",
						modifier: (value, row) => {
							let status = (value == 1) ? this.$t('status_renewe_process') : this.$t('status_renewe_done');
							let color = (value == 1) ? 'badge-danger' : 'badge-success';
							return '<span class="badge badge ' + color + ' badge-pill mr-2">' + status + '</span>';
						},
					},
					{
						title: this.$t("price"),
						type: "custom-html",
						key: "price",
						modifier: (value, row) => {
							return this.numberWithCurrencyMuseum(value);
						},
					},
					{
						title: this.$t("person_res"),
						type: "custom-html",
						key: "person",
						modifier: (value, row) => {
							return '<a href="/crm/persons/' + value.id + '/edit">' + value.name + '</a>';
							
						},
					},
					{
						title: this.$t("button_link"),
						type: "button-link",
						titleAlignment: 'right',
						key: "id",
						modifier: (value, row) => {
							return '<a href="/crm/renewes/' + value + '/edit" class="badge badge badge-primary">' + this.$t('edit_more') + '</a>';
							
						},
					},
					
				],
				
				showSearch: false,
				showFilter: false,
				paginationType: "pagination",
				responsive: false,
				rowLimit: 10,
				showAction: false,
				orderBy: "desc",
				actionType: "dropdown",
				
			};
			this.loadRenewe = true;
		},
		

		updateRequest() {
			this.isComponent = false;
			this.axiosGet(this.selectedUrl).then((response) => {
				this.formData = response.data;
				this.name = this.formData.name;
				this.isComponent = true;
				this.blockEdit = false;

			}).catch((error) => console.log(error));
		},
		updateBlock() {
			this.blockEdit = true;
		},
		updateUnblock() {
			this.blockEdit = false;
		},

		
	
		
		

		editNote(activity) {
			this.isNoteModal = true;
			this.noteRowData = activity;
			setTimeout(() => {
				$("#note-modal").modal("show");
			});
		},
		closeNoteModal() {
			this.isNoteModal = false;
			$("#note-modal").modal("hide");
		},
	},

	mounted() {
		
		this.setUser();
		//this.$store.dispatch("getFund");
		
		
		//this.$store.dispatch("getRestorer");
		this.$store.dispatch("getInrest");
		this.$store.dispatch("getInv");
		this.$store.dispatch("getZal");
		this.$store.dispatch("getYesno");
		
		
	},
};
</script>

<style>
.card-renewe .datatable .table-responsive {
  min-height: auto !important;
}
</style>


